import { useState, useEffect, useCallback, useMemo } from 'react'
import { getEvent } from '../../services/eventService.service'

const MAX_NOTIFICATIONS = 20

const mapEventType = (eventType) => {
  const t = (eventType || '').toLowerCase()
  if (t.includes('speed') || t.includes('vitesse') || t.includes('overspeed')) return 'alert'
  if (t.includes('geofence') || t.includes('zone') || t.includes('sortie') || t.includes('entree') || t.includes('entrée')) return 'geofence'
  if (t.includes('offline') || t.includes('disconnect') || t.includes('deconnect') || t.includes('perte') || t.includes('inactif')) return 'maintenance'
  return 'info'
}

const formatNotification = (event) => ({
  id: String(event.id || event.event_id || Date.now() + Math.random()),
  type: mapEventType(event.event_type || event.type),
  title: event.event_type || event.type || 'Événement',
  description: [
    event.plate_number || event.matricule || event.device_name || '',
    event.address || event.position || event.message || '',
  ].filter(Boolean).join(' — ') || 'Détail non disponible',
  time: event.event_time
    ? new Date(event.event_time).getTime()
    : (event.created_at ? new Date(event.created_at).getTime() : Date.now()),
  read: false,
  raw: event,
})

const useNotifications = () => {
  const [notifications, setNotifications] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false

    const fetchNotifications = async () => {
      setLoading(true)
      try {
        const res = await getEvent()
        if (cancelled) return

        let events = []
        if (Array.isArray(res.data)) {
          events = res.data
        } else if (res.data && Array.isArray(res.data.items)) {
          events = res.data.items
        } else if (res.data && Array.isArray(res.data.data)) {
          events = res.data.data
        }

        const mapped = events.slice(0, MAX_NOTIFICATIONS).map(formatNotification)
        setNotifications(mapped)
      } catch (err) {
        console.error('Erreur chargement notifications:', err)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchNotifications()

    const interval = setInterval(fetchNotifications, 60000)
    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [])

  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.read).length,
    [notifications]
  )

  const markAsRead = useCallback((id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true } : n))
    )
  }, [])

  const markAllAsRead = useCallback(() => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })))
  }, [])

  const addNotification = useCallback((notification) => {
    const newNotification = {
      id: String(Date.now()),
      read: false,
      time: Date.now(),
      ...notification,
    }
    setNotifications((prev) => [newNotification, ...prev])
  }, [])

  return {
    notifications,
    unreadCount,
    loading,
    markAsRead,
    markAllAsRead,
    addNotification,
  }
}

export default useNotifications
